import { render, staticRenderFns } from "./ImportRecord.vue?vue&type=template&id=d38a4422"
import script from "./ImportRecord.vue?vue&type=script&lang=js"
export * from "./ImportRecord.vue?vue&type=script&lang=js"
import style0 from "./ImportRecord.vue?vue&type=style&index=0&id=d38a4422&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports